<template>
    <FullWidthMessage>
        <template #title>
            <slot name="title">
                {{ t('globals.critical_error_title') }}
            </slot>
        </template>

        <template #default>
            <div
                v-for="error in errors.serverErrors"
                :key="error.sentryEventId"
            >
                {{ error.message }}
            </div>
        </template>
    </FullWidthMessage>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import type { ErrorCollectionWithTraces } from '@/helpers/errors'

import FullWidthMessage from '../FullWidthMessage.vue'

defineProps<{
    errors: ErrorCollectionWithTraces
}>()

const { t } = useI18n()
</script>
